import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { FlamingoAuthService } from '@flamingo/service/flamingo-auth.service';

export const flamingoHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(FlamingoAuthService);
    const router = inject(Router);
    const token = authService.getToken();

    console.log('[FlamingoHttpInterceptor] Request URL:', req.url);
    console.log('[FlamingoHttpInterceptor] Token available:', !!token);
    console.log('[FlamingoHttpInterceptor] Token value:', token ? `${token.substring(0, 20)}...` : 'none');

    // Check if token is valid before adding it
    if (!token || !authService.isTokenValid()) {
        if (token && !authService.isTokenValid()) {
            console.warn('[FlamingoHttpInterceptor] Token is expired, clearing and redirecting to login');
            authService.logout();
            router.navigate(['/auth']);
        }
        console.warn('[FlamingoHttpInterceptor] No valid token found, sending request without Authorization header');
        return next(req);
    }

    const cloned = req.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`
        }
    });

    console.log('[FlamingoHttpInterceptor] Added Authorization header');
    return next(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
            // Handle 401 Unauthorized errors
            if (error.status === 401) {
                console.warn('[FlamingoHttpInterceptor] Received 401 Unauthorized, logging out and redirecting to login');
                authService.logout();
                router.navigate(['/auth']);
            }
            return throwError(() => error);
        })
    );
};



